import axios from 'axios';
import { EntityState, serializeAxiosError, IQueryParams } from 'app/shared/reducers/reducer.utils';
import { IIndicatorDto, defaultValue } from 'app/shared/model/indicator-dto.model';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IKpiResponse, IKpiTimeResponse } from 'app/shared/model/indicator-dto';
import { PeriodicType } from 'app/shared/model/enumerations/periodicType';

const initialState: EntityState<IIndicatorDto> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};
export interface IIndicatorABSProps extends IQueryParams {
  sensor: string | null;
  periodicType: PeriodicType | null;
  truckImplementId?: number | string;
  companyId?: number | null;
  dateStart?: string | null;
  dateEnd?: string | null;
}

const apiUrl = '/api/indicator-difference';

// Actions

export const getAbsPerTime = createAsyncThunk(
  'indicatorAbs/fetch_abs_per_time_periodic',
  async ({ sensor, periodicType, truckImplementId, companyId, dateStart, dateEnd }: IIndicatorABSProps) => {
    const apiUrlComplete = `${apiUrl}/time/${sensor}${truckImplementId ? `/${truckImplementId}` : ''}/${periodicType}${
      companyId ? `?searchCompanyId=${companyId}` : ''
    }`;
    const params = {
      dateStart,
      dateEnd,
    };
    const response = await axios.get<IKpiTimeResponse>(apiUrlComplete, { params });
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

export const getAbsPerVehicleAndPlate = createAsyncThunk(
  'indicatorAbs/fetch_abs_per_vehicles_and_plate_periodic',
  async ({ sensor, periodicType, companyId, dateStart, dateEnd }: IIndicatorABSProps) => {
    const apiUrlComplete = `${apiUrl}/statistics/${sensor}/${periodicType}${companyId ? `?searchCompanyId=${companyId}` : ''}`;
    const params = {
      dateStart,
      dateEnd,
    };
    const response = await axios.get<IKpiResponse>(apiUrlComplete, { params });
    return response.data;
  },
  { serializeError: serializeAxiosError }
);

// Slice

const indicatorAbsSlice = createSlice({
  name: 'indicatorAbs',
  initialState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getAbsPerTime.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiPerTime = action.payload;
      })
      .addCase(getAbsPerTime.pending, state => {
        state.loading = true;
      })
      .addCase(getAbsPerTime.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      })
      .addCase(getAbsPerVehicleAndPlate.fulfilled, (state, action) => {
        state.loading = false;
        state.entity.kpiPerVehicleAndStatistics = action.payload;
      })
      .addCase(getAbsPerVehicleAndPlate.pending, state => {
        state.loading = true;
      })
      .addCase(getAbsPerVehicleAndPlate.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.error.message || 'Error fetching data';
      });
  },
});

export const { reset } = indicatorAbsSlice.actions;

export default indicatorAbsSlice.reducer;
